import React from 'react';

import {CircularLoader} from '@optimaxdev/design-system';

import {PaymentFooterSubscriptionDisclaimerConnected} from '../paymentFooterSubscriptionDisclaimer/paymentFooterSubscriptionDisclaimer';
import {PaymentMoneyBackGuaranteeConnected} from '../paymentMoneyBackGuarantee/paymentMoneyBackGuarantee';
import {PaymentStepAgreement} from '../paymentStepAgreement/paymentStepAgreement';
import {PlaceOrderConnected} from '../placeOrder/placeOrder';

type PropsType = {
    isLoading?: boolean;
    onSubmit?: () => void;
    isOneStepLoading?: boolean;
};

import s from './paymentFooter.scss';

/**
 * Payment Footer for checkout
 *
 * @constructor
 */
export const PaymentFooter: React.FC<PropsType> = ({
    isLoading = false,
    isOneStepLoading = false,
    onSubmit,
}) => (
    <>
        {isOneStepLoading ? (
            <div className={s.loadingBlock}>
                <CircularLoader color="#0f0f0f" size={32} />
            </div>
        ) : (
            <PlaceOrderConnected isLoading={isLoading} onSubmit={onSubmit} />
        )}
        <PaymentMoneyBackGuaranteeConnected />
        <PaymentStepAgreement />
        <PaymentFooterSubscriptionDisclaimerConnected />
    </>
);
